<small class="debug">{{me}}</small>
<div [@fadeIn]="getState()">
    <router-outlet></router-outlet>
    <div class="test-container">
        <h2>Rich Text Editor Test</h2>
        <!-- <app-rich-text
            [(ngModel)]="testContent"
            placeholder="Test the rich text editor here"
            minHeight="300px"
            maxHeight="600px">
        </app-rich-text> -->
        <!-- <editor
            [(ngModel)]="content"
            [init]="editorConfig"
            licenseKey="gpl"
            apiKey="9d1khyvhwg1gb4s89gn0xbd5zgwnfbg3vodfkdn9frnpbcm2"
        ></editor> -->
        <angular-editor 
            [config]="editorConfig"
            [placeholder]="'Enter text here...'"
            [(ngModel)]="testContent">
        </angular-editor>

        <div>
            {{testContent}}
        </div>

    </div>
</div>
